
import { Vue, Component } from "vue-property-decorator";
import { AmHint, AmHintDialog } from "@afe/amui/src/components/Hint";
import { AmResponsive } from "@afe/amui/src/components/Responsive";

@Component({
  components: { AmHint, AmHintDialog, AmResponsive }
})
export default class extends Vue {}
